const { adminCall } = require("./_utils");

module.exports = {
  create: (data) => adminCall("theme.create", data),
  modify: (data) => adminCall("theme.modify", data),
  remove: (uid) => adminCall("theme.remove", {uid}),
  select: themeUid => adminCall("theme.selection", {themeUid})
}
